import React from 'react';
type SectionTitleProps = {
  children: React.ReactNode;
  eyebrow?: string;
  as?: 'h2' | 'h3';
  align?: 'left' | 'center';
  className?: string;
};
export function SectionTitle({
  children,
  eyebrow,
  as: Tag = 'h2',
  align = 'center',
  className = ''
}: SectionTitleProps) {
  return <div className={`${align === 'center' ? 'text-center' : 'text-left'} ${className}`} data-id="element-135" data-mp="4qh59dfcj2q9">
      {eyebrow}
      <Tag className={`font-display text-[30px] font-semibold leading-[1.15] text-ink sm:text-[38px] ${eyebrow ? 'mt-3' : ''}`} style={{
      fontSize: '30px',
      textAlign: 'center'
    }} data-id="element-136" data-mp="3m6p54m32zj86">
        {children}
      </Tag>
    </div>;
}